import { render, staticRenderFns } from "./DesignOwnerList.vue?vue&type=template&id=d268cbde&"
import script from "./DesignOwnerList.vue?vue&type=script&lang=js&"
export * from "./DesignOwnerList.vue?vue&type=script&lang=js&"
import style0 from "./DesignOwnerList.vue?vue&type=style&index=0&id=d268cbde&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports